import { createInstance, dateReviver } from '@/api';
import { ProductGroupClient, ProductGroupSelectableDefinitionDto } from '@/api/backoffice/clients';
import { i18n } from '@/i18n';
import { useAlertStore } from '@/modules/core/store/alert.store';
import { defineStore } from 'pinia';

export interface ProductGroupDefinitionsStoreState {
    definitions?: ProductGroupSelectableDefinitionDto[];
    loading: boolean;
}

export const client = new ProductGroupClient('', createInstance(), dateReviver);

export const useProductGroupDefinitionsStore = defineStore('configuration-product-group-definitions-store', {
    state: (): ProductGroupDefinitionsStoreState => ({
        definitions: [],
        loading: false
    }),
    getters: {},
    actions: {
        // The create and the edit screen offer the same list, so it is fetched once and kept.
        async getSelectableDefinitions() {
            this.loading = true;

            if (!this.definitions?.length) {
                try {
                    this.definitions = await client.getSelectableDefinitions();
                } catch (error) {
                    useAlertStore().handleException(
                        i18n.global.t('productgroup.detail.error.definitions.title'),
                        error,
                        false
                    );
                }
            }

            this.loading = false;
            return this.definitions;
        }
    }
});
